import * as React from 'react';
import { SvgIcon } from '../SvgIcon';

interface IProps {
	className?: string;
	fill?: string;
	height?: number;
	width?: number;
}

export const ExpandedViewIcon: React.FC<IProps> = props => {
	const { className, fill, height = 16, width = 18 } = props;
	return (
		<SvgIcon
			className={className ?? ''}
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g id='Design' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g id='Contact-Profile-Copy' transform='translate(-946, -94)' fill='#0066FF'>
					<g id='Group-12' transform='translate(897.0631, 89)'>
						<g id='Group-11' transform='translate(49.8523, 5)' fill={fill}>
							<path
								d='M14.1176471,14 L10.0840336,14 L10.0840336,16 L14.1176471,16 C15.229916,16 16.1344538,15.102 16.1344538,14 L16.1344538,10 L14.1176471,10 L14.1176471,14 Z'
								id='Fill-2350'
							/>
							<path
								d='M14.1176471,0 L10.0840336,0 L10.0840336,2 L14.1176471,2 L14.1176471,6 L16.1344538,6 L16.1344538,2 C16.1344538,0.897 15.229916,0 14.1176471,0'
								id='Fill-2351'
							/>
							<path
								d='M2.01680672,2 L6.05042017,2 L6.05042017,0 L2.01680672,0 C0.904537815,0 0,0.897 0,2 L0,6 L2.01680672,6 L2.01680672,2 Z'
								id='Fill-2352'
							/>
							<path
								d='M2.01680672,10 L0,10 L0,14 C0,15.102 0.904537815,16 2.01680672,16 L6.05042017,16 L6.05042017,14 L2.01680672,14 L2.01680672,10 Z'
								id='Fill-2353'
							/>
						</g>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
};
